export default dimensions => (a, b) => Math.sqrt(dimensions
  .reduce((accumulator, dimension) =>
    accumulator + Math.pow((b[dimension] - a[dimension]), 2), 0))
